<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!--      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
      <el-breadcrumb-item>分析列表</el-breadcrumb-item>
      <!--      <quit-project/>-->
    </el-breadcrumb>

    <p id="analysisNumText" :style="this.analysisOver?'color: #b92c28;':'color:#C0C0C0;'">
      分析数：{{ this.analysisNum }}/20（{{ this.analysisOver ? '达到上限' : '未达上限' }}）</p>
    <!--    <el-button style="width: 150px" type="primary" :disabled="this.analysisOver" :title="this.analysisOver ?'当前分析数目达到上限':''"  class="btn-add" @click="showAddAnalyzeDialog">新建分析</el-button>-->
    <!--    <el-button type="primary" class="btn-add" @click="downloadProjectAll">下载所有数据</el-button>-->
    <!-- 主体部分 -->
    <el-card class="box-card">
      <template>
      </template>
      <search-sort-tag :sortList="sortList" :searchConditionTag="searchConditionTag" @deleteSelect="deleteSelect" @deleteSort="deleteSort"></search-sort-tag>
      <a-config-provider :locale="locale">
        <a-table :data-source="analyzeData" :columns="columns"
                 bordered
                 @change="changeTable" :pagination="false"
                 :rowKey="(record) => record.analyze.analyzeId"
                 :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                 :scroll="{x:'max-content'}">
          <span slot="customAnalyze" slot-scope="text, record">
                            <span class="setting-text-one-row" v-if="record.analyze.execStatus===2"
                                  style="cursor:default;">
                              <div class="setting-btn-bgc"
                                   @click="showUpdateAnNameDialog(record.analyze.analyzeId, record.analyze.analyzeName)">
                                <i class="iconfont icon-xiugai" style="color: #409EFF;"></i>
                              </div>
                              <a href="#" v-if="record.analyze.execStatus == 2"
                                 @click.prevent="toContentAnalyzeHome(record.analyze.analyzeId)">
                                {{ record.analyze.analyzeName }}
                              </a>
                            </span>
                            <span v-else>
                              <span class="setting-btn-bgc"
                                    @click="showUpdateAnNameDialog(record.analyze.analyzeId, record.analyze.analyzeName)">
                                <i class="iconfont icon-xiugai" style="color: #409EFF;"></i>
                              </span>{{ record.analyze.analyzeName }}
                            </span>

         </span>
          <span slot="customExeSta" slot-scope="text, record">
                          <div style="width: 80px">
                              <el-tag  type="info" round size="mini" v-if="text === 0"
                                      style="width: 80px;height: 28px;text-align: center;font-size: medium;padding-top: 4px">未执行</el-tag>
                              <el-tag type="warning" v-if="text === 1" style="width: 80px; ">运行中
                                <img src="image/running2.gif">
                              </el-tag>
                              <el-tag type="success" round size="mini" v-if="text === 2"
                                      style="width: 80px;height: 28px;text-align: center;padding-top: 4px">已完成</el-tag>
                              <el-tag type="danger" round size="mini" v-if="text === 3"
                                      style="width: 80px;height: 28px;text-align: center;padding-top: 4px">运行失败</el-tag>
                            </div>
          </span>
          <span slot="groupState" slot-scope="text, record">
                          <span style="width: 80px">
                            {{ text ? '无分组' : '有分组' }}
                            </span>
          </span>
          <div
            slot="operation"
            slot-scope="text, record">
            <div>
              <el-button type="success" plain v-show="record.analyze.execStatus === 2"
                         @click="downloadAnalyzeAll(record.analyze.analyzeId,record.analyze.analyzeName)"
                         size="small">下载报告
              </el-button>
              <el-button type="primary" plain size="small" @click="preAnalyzeReRun(record.analyze.analyzeId)"
                         class="btn-width-setting" :style="record.analyze.execStatus === 2?'':'margin-left: 0px'"
                         v-show="record.analyze.execStatus !== 1">
                重新运行
              </el-button>
              <el-button type="warning" plain size="small" @click="lookAnalyzeDetail(record.analyze)" :style="record.execStatus === 2?'':'margin-left: 10px'"
                         class="btn-width-setting">
                分析数据
              </el-button>
            </div>
            <div style="margin-top: 8px">
              <el-button type="info" plain @click="showExecLog(record.analyze)"
                         size="small">查看日志
              </el-button>
              <el-button type="danger" plain size="small" @click="prepareDelete(record.analyze.analyzeId)"
                         class="btn-width-setting"
                         style="width:55px;height: 30px">
                删除
              </el-button>

            </div>


          </div>
          <div
            slot="filterDropdown"
            slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters }"
            style="padding: 8px; position: relative; z-index: 9999 !important;"
          >
            <a-input
              v-ant-ref="c => (searchInput = c)"
              :placeholder="`搜索 ${column.title}`"
              v-model="selectedKeys[0]"
              style="width: 188px; margin-bottom: 8px; display: block;"
              @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
              @pressEnter="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)"
            />
            <a-button
              type="primary"
              icon="search"
              size="small"
              style="width: 90px; margin-right: 8px"
              @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)"
            >
              搜索
            </a-button>
            <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">
              取消
            </a-button>
          </div>
          <div slot="filterType" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters }"
               style="padding: 8px; position: relative; z-index: 9999 !important;">
            <div v-if="column.dataIndex==='analyze.execStatus'" style="padding: 0px 15px">
              <el-radio-group v-model="selectedKeys[0]">
                <div style="display: flex">
                  <el-radio label="未执行">未执行</el-radio>
                  <el-radio label="运行中">运行中</el-radio>
                </div>
                <div style="display: flex">
                  <el-radio label="已完成">已完成</el-radio>
                  <el-radio label="执行失败">执行失败</el-radio>
                </div>
              </el-radio-group>
            </div>
            <div v-else>
              <el-radio-group v-model="selectedKeys[0]">
                <div style="display: flex">
                  <el-radio label="有分组">有分组</el-radio>
                  <el-radio label="无分组">无分组</el-radio>
                </div>
              </el-radio-group>
            </div>
            <div style="display: flex;padding: 15px">
              <a-button
                type="primary"
                icon="search"
                size="small"
                style="width: 90px; margin-right: 8px"
                @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">搜索
              </a-button>
              <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
              </a-button>
            </div>
          </div>
          <div
            slot="time"
            slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters }"
            style="padding: 8px">
            <a-date-picker
              v-model="selectedKeys[0]"
              placeholder="起始时间：xx/xx/xx/"
              style="width: 188px; margin-bottom: 8px; display: block;"
            />
            <a-date-picker
              v-model="selectedKeys[1]"
              placeholder="结束时间：xx/xx/xx/"
              style="width: 188px; margin-bottom: 8px; display: block;"
            />
            <a-button
              type="primary"
              icon="search"
              size="small"
              style="width: 90px; margin-right: 8px"
              @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)"
            >
              搜索
            </a-button>
            <a-button size="small" style="width: 90px" @click="() => handleReset(column,clearFilters)">
              取消
            </a-button>

          </div>
          <a-tooltip placement="topLeft" title="搜索" slot="filterIcon" slot-scope="filtered">
            <a-icon
              type="filter"
              :style="{ color: filtered ? '#108ee9' : undefined,title:'搜索'}"
            />
          </a-tooltip>
          <template slot="customRender" slot-scope="text, record, index, column">
      <span v-if="searchText && searchedColumn === column.dataIndex">
        <template
          v-for="(fragment, i) in text
            .toString()
            .split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))"
        >
          <mark
            v-if="fragment.toLowerCase() === searchText.toLowerCase()"
            :key="i"
            class="highlight"
          >{{ fragment }}</mark
          >
          <template v-else>{{ fragment }}</template>
        </template>
      </span>
            <template v-else>
              {{ text }}
            </template>
          </template>
        </a-table>
      </a-config-provider>
      <br>
      <pagination :child-msg="analyzePageChildMsg" @callFather="handlePagePagination"></pagination>

    </el-card>
    <el-dialog
      :destroy-on-close="true"
      title="修改分析名"
      :visible.sync="showUpdateAnalyzeNameDialog"
      width="50%"
    >
      <el-form ref="form" :model="updatedAnalyze" label-width="80px">
        <el-form-item>
          <el-input id="setFont" type='text' style="width: 40% ;margin-bottom: 8px;" :disabled="true"
                    :placeholder="updatedAnalyze.showAnalyzeName"></el-input>
          <i class="el-icon-right" style="color: #3967FF"> </i><i class="el-icon-right" style="color: #3967FF"> </i>
          <el-input type='text' style=" width: 40%" v-model.trim="updatedAnalyze.analyzeName"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showUpdateAnalyzeNameDialog = false">取 消</el-button>
        <el-button type="primary" @click="updateAnalyzeName">确 定</el-button>
      </span>
    </el-dialog>
    <re-run-analyze v-if="showReRunAnalyzeDialog" :groupSampleData="reRunGroupSample" @submitData="reRunAnalyze"
                    :analyze-id="reRunAnalyzeId"></re-run-analyze>
    <task-log :showTaskLog="log.showTaskLog" :logContent="log.logContent" @callFather="closeTaskLog"></task-log>
    <picture-loading v-if="loadingAnalyze"></picture-loading>
    <el-dialog
      :destroy-on-close="true"
      title="查看分析数据"
      :visible.sync="isShowAnalyzeDetail"
      width="50%">
      <analyze-info :project-id="showProjectId" :analyze-id="showAnalyzeId"  v-if="isShowAnalyzeDetail"></analyze-info>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="isShowAnalyzeDetail= false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import {addT, DataConvert, downloadBlob} from '@/utils/utils'
import MyResult from '@/components/MyResult'
import {downloadProgress} from '@/mixins/downloadProgress.js'
import TaskLog from '@/components/TaskLog'
import {defaultColor} from '@/utils/PublicConstant'
import QuitProject from '@/components/QuitProject'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import { downReport} from "@/utils/download";
import PictureLoading from "@/components/PictureLoading";
import {getDataInLocalStorage} from "@/utils/localStorageUtils";
import ReRunAnalyze from "@/components/ReRunAnalyze";
import {checkReportDownload, getAnalyzeGroupSampleNames, reRunAnalyze} from "@/api/analyze/analyze";
import {myMixins} from "@/mixins/tableOperation";
import SearchSortTag from "@/components/SearchSortTag";
import AnalyzeInfo from '@/components/AnalyzeInfo'

const baseURL = process.env.VUE_APP_BASE_API
const baseURLWs = process.env.VUE_APP_BASE_WS
export default {
  mixins: [downloadProgress,myMixins],
  components: {
    ReRunAnalyze,
    PictureLoading,
    'pagination': Pagination,
    'my-result': MyResult,
    "quit-project": QuitProject,
    'task-log': TaskLog,
    'search-sort-tag':SearchSortTag,
    'analyze-info': AnalyzeInfo,
  },
  data() {
    return {
      locale: zhCN,
      selectSort: [],
      isShowAnalyzeDetail: false,
      //项目数据里的项目号和分析号
      showProjectId: '',
      showAnalyzeId: '',
      log: {
        showTaskLog: false,
        logContent: ""
      },
      loadingAnalyze: true,
      updatedAnalyze: {
        analyzeId: '',
        analyzeName: '',
        showAnalyzeName: ''
      },
      showMyResult: false,
      myResultTitle: '没有合适的分组',
      groupAddForm: {
        groups: [],
        function: 'bc',
        groupColor: [],
      },
      reRunGroupSample: {},
      showGroupSample: '',
      groupsSampleData: '',
      addAnalyzeDialog: false,
      projectId: '',
      analyzeData: [],
      analyzePageChildMsg: {
        total: 0,
        pageSize: 8,
        currentNum: 1
      },
      analyzeDataPageparm: {
        currentNum: 1,
        pageSize: 8
      },
      showReRunAnalyzeDialog: false,
      showUpdateAnalyzeNameDialog: false,
      defaultColor: defaultColor,
      analysisOver: true,
      analysisNum: 0,
      reRunAnalyzeId: '',
      columns: [
        {
          title: '分析名',
          dataIndex: 'analyze.analyzeName',
          key: 'analyze.analyzeName',
          sorter: true,
          sortDirections: ["descend", "ascend", "descend"],
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customAnalyze',
          },
        },
        {
          title: '创建者',
          dataIndex: 'createUser.userName',
          key: 'analyze.userName',
          sorter: true,
          sortDirections: ["descend", "ascend", "descend"],
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
          },
        },
        {
          title: '创建时间',
          dataIndex: 'analyze.createTime',
          key: 'analyze.createTime',
          sorter: true,
          sortDirections: ["descend", "ascend", "descend"],
          scopedSlots: {
            filterDropdown: 'time',
            filterIcon: 'filterIcon',
          },
        },

        {
          title: '执行时间',
          dataIndex: 'analyze.submitTime',
          key: 'analyze.submitTime',
          sorter: true,
          sortDirections: ["descend", "ascend", "descend"],
          scopedSlots: {
            filterDropdown: 'time',
            filterIcon: 'filterIcon',
          },
        },
        {
          title: '结束时间',
          dataIndex: 'analyze.finishTime',
          key: 'analyze.finishTime',
          sorter: true,
          sortDirections: ["descend", "ascend", "descend"],
          scopedSlots: {
            filterDropdown: 'time',
            filterIcon: 'filterIcon',
          },
        },
        // {
        //   title: '分组状态',
        //   dataIndex: 'analyze.nongroup',
        //   key: 'analyze.nongroup',
        //   sorter: true,
        //   sortDirections: ["descend", "ascend", "descend"],
        //   scopedSlots: {
        //     filterDropdown: 'filterType',
        //     filterIcon: 'filterIcon',
        //     customRender: 'groupState',
        //   },
        // },
        {
          title: '状态',
          dataIndex: 'analyze.execStatus',
          key: 'analyze.execStatus',
          sorter: true,
          sortDirections: ["descend", "ascend", "descend"],
          scopedSlots: {
            filterDropdown: 'filterType',
            filterIcon: 'filterIcon',
            customRender: 'customExeSta',
          },
        },
        {
          title: '操作',
          key: 'operation',
          scopedSlots: {customRender: 'operation'},
          width: 300,

        }
      ],
      searchCondition: new Map,
      searchConditionTag: [],
      searchText: '',
      searchInput: null,
      searchedColumn: '',
      sortList: '',
      inputSearch: '',
    }
  },
  created: function () {
    this.projectId = this.$route.query.projectId
    var projectAll = this.$store.getters['right/getUser']
    if (!this.projectId && projectAll && projectAll.projectsRow) {
      this.projectId = projectAll.projectsRow.projectId
    }
    let that = this
    this.getAnalyzeData().then(() => {
      that.connectWs()
    })
    this.updateIsAnalysisOver()
  },
  mounted() {
  },

  methods: {
    // 创建一个 websocket 连接
    connectWs() {
      // 创建一个 websocket 连接  ws://ip:端口号
      // this.ws = new WebSocket('ws://' + window.location.host + '/api/ws/ws/WebSocketController/socket');// 服务器后端为去掉ws
      // this.ws = new WebSocket('ws://' + window.location.host + '/api/ws/WebSocketController/socket');
      // this.ws = new WebSocket("ws://192.168.0.103:15000/WebSocketController/socket");
      this.ws = new WebSocket(`${baseURLWs}WebSocketController/socket`);
      // 连接状态 1已建立连接
      console.log(this.ws, baseURLWs)
      //  连接建立时触发
      this.ws.onopen = () => {
        const projectId = this.projectId
        this.ws.send(projectId);
      };
      // 客户端接收服务端数据时触发
      this.ws.onmessage = (event) => {
        if (event.data === 'oneFinish' || event.data === "finish") {
          this.getAnalyzeData()
        }
      };

      // 连接关闭时触发
      this.ws.onclose = () => {
      };
      //  通信发生错误时触发
      this.ws.onerror = () => {
        this.ws.close()
        this.ws = new WebSocket(`${baseURLWs}WebSocketController/socket`);
        // console.log("重新连接",this.ws)
      };
    },
    //关闭日志
    closeTaskLog() {
      this.log.showTaskLog = false
      this.wsRunTimeLog.close()
    },
    //查看日志
    async showExecLog(analyze) {
      if (analyze.execStatus !== 1) {
        const res = await this.$http.get('analyze/log/' + analyze.analyzeId)
        this.log.showTaskLog = true
        this.log.logContent = res.data.split('\n')
      } else {
        this.wsRunTimeLog = new WebSocket(`${baseURLWs}analyze/runtimeLog/${analyze.analyzeId}`,[getDataInLocalStorage('token')]);
        // 连接状态 1已建立连接
        //  连接建立时触发
        this.wsRunTimeLog.onopen = () => {
          this.log.showTaskLog = true
          this.wsRunTimeLog.send('a');
        }
        this.wsRunTimeLog.onmessage = (event) => {
          let data=JSON.parse(event.data)
          let arr=[]
          arr.push(data.startTime?`开始执行时间：${data.startTime}`:'')
          arr.push(data.currentScript?`当前执行到的脚本：${data.currentScript}`:'')
          this.log.logContent =data.logs.concat(arr)
          console.log(data.logs)
          if(data.logs.length<1){
            this.wsRunTimeLog.close()
            this.log.showTaskLog = false
            this.$http.get('analyze/log/' + analyze.analyzeId).then(res=>{
              this.log.showTaskLog = true
              this.log.logContent = res.data.split('\n')
            })
          }
        }
        this.wsRunTimeLog.onerror = () => {
        }
      }
    },
    // 删除分析
    handleDelByAnalyzeId(analyzeId) {
      var that = this
      this.$http.delete('analyze', {
        data: {
          analyzeId: analyzeId
        }
      }).then(res => {
        if (res.code === 200) {
          that.$messageUi.success('删除成功')
          const totalPage = Math.ceil((this.analyzePageChildMsg.total - 1) / this.analyzePageChildMsg.pageSize)
          this.analyzePageChildMsg.currentNum =  this.analyzePageChildMsg.currentNum> totalPage ? totalPage : this.analyzePageChildMsg.currentNum
          this.analyzePageChildMsg.currentNum =  this.analyzePageChildMsg.currentNum < 1 ? 1 : this.analyzePageChildMsg.currentNum
          that.getAnalyzeData()
          that.updateIsAnalysisOver()
        } else {
          that.$messageUi.error(res.message)
        }
      }).catch(error => {
        that.$messageUi.error('删除失败，请稍后再重试')
      })
    },
    //点击删除分析按钮
    async prepareDelete(analyzeId) {
      const res = await this.$confirmUi('此操作将永久删除该分析, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      console.log(res)
      if (res === 'confirm') {
        await this.handleDelByAnalyzeId(analyzeId)
      }
    },
    //点击重新运行按钮
    preAnalyzeReRun(analyzeId) {
      getAnalyzeGroupSampleNames(analyzeId).then(data => {
        const groupSampleName=data.groupSample
        if (groupSampleName) {
          this.reRunGroupSample = data
          this.showReRunAnalyzeDialog = true
          this.reRunAnalyzeId = analyzeId
        } else {
          this.$messageUi.error('重新运行失败，获取分组名，样本名失败，请稍后再试')
        }
      }).catch(err => {
        this.$messageUi.error('重新运行失败，获取分组名，样本名失败，请稍后再试')
      })
    },
    //重跑分析
    reRunAnalyze(groupColor, analyzeId, type) {
      this.reRunAnalyzeId = ''
      this.showReRunAnalyzeDialog = false
      if (type === 'confirm') {
        reRunAnalyze(groupColor, analyzeId).then(res => {
          if (res === 'success') {
            this.$messageUi.success("重新运行成功")
            this.getAnalyzeData()
            this.connectWs()
          }
        }).catch(err => {
          this.$messageUi.error("重新运行失败")
        })
      }
    },
    //更改分析名
    async updateAnalyzeName() {
      if (!this.updatedAnalyze.analyzeName) {
        this.$messageUi.error('分析名不能为空')
        return
      }
      this.showUpdateAnalyzeNameDialog = false
      const res = await this.$http.put('analyze/name', {
        analyzeId: this.updatedAnalyze.analyzeId,
        analyzeName: this.updatedAnalyze.analyzeName
      })
      if (res.code === 200) {
        this.$messageUi.success('修改成功')
        this.getAnalyzeData()
      } else {
        this.$messageUi.error(res.message)
      }
    },
    //展示修改分析名的dialog
    showUpdateAnNameDialog(analyzeId, analyzeName) {
      this.updatedAnalyze.analyzeId = analyzeId
      this.updatedAnalyze.analyzeName = analyzeName
      this.updatedAnalyze.showAnalyzeName = analyzeName
      this.showUpdateAnalyzeNameDialog = true
    },
    downloadProjectAll() {
      const formData = new FormData
      formData.append('projectId', this.projectId)
      this.$download('project/downloadAll', formData)
    },
    //下载分析报告
    downloadAnalyzeAll(analyzeId, analyzeName) {
      downReport(analyzeId).then(msg=>{
        if (msg!=='ok'){
          this.$messageUi.error(msg)
        }
      }).catch(err=>{
        this.$messageUi.error(err)
      })
    },
    //获取分析
    async getAnalyzeData() {
      var sendData = {
        pageNum: this.analyzeDataPageparm.currentNum,
        pageSize: this.analyzeDataPageparm.pageSize,
        projectId: this.projectId
      }
      let length = this.searchConditionTag.length
      if (length) {
        sendData.search = {}
        this.searchConditionTag.forEach(item => {
          let key = item.key
          if (key === 'analyze.analyzeName') {
            sendData.search.analyzeName = item.value
          } else if (key === 'createUser.userName') {
            sendData.search.createUser = item.value
          } else if (key === 'analyze.execStatus') {
            let value = item.value
            let value1
            if (value === '未执行') {
              value1 = 0
            } else if (value === '运行中') {
              value1 = 1
            } else if (value === '已完成') {
              value1 = 2
            } else {
              value1 = 3
            }
            sendData.search.execStatus = Array.of(value1)
          } else if (key === 'analyze.nongroup') {
            let value = item.value
            if (value === '有分组') {
              value = false
            } else {
              value = true
            }
            sendData.search.nonGroup = Array.of(value)
          } else if (key === 'analyze.createTime') {
            let value = item.value
            let index = value.indexOf('至')
            let value1 = value.substring(0, index)
            let value2 = value.substring(index + 1, value.length)
            let time = [addT(value1), addT(value2)]
            sendData.search.createTime = time
          } else if (key === 'analyze.submitTime') {
            let value = item.value
            let index = value.indexOf('至')
            let value1 = value.substring(0, index)
            let value2 = value.substring(index + 1, value.length)
            let time = [addT(value1), addT(value2)]
            sendData.search.execTime = time
          } else if (key === 'analyze.finishTime') {
            let value = item.value
            let index = value.indexOf('至')
            let value1 = value.substring(0, index)
            let value2 = value.substring(index + 1, value.length)
            let time = [addT(value1), addT(value2)]
            sendData.search.finishedTime = time
          } else {
            sendData.search.category = item.value
          }
        })
      } else {
        sendData.search = {}
      }
      sendData.sorts = this.selectSort
      const res = await this.$http.post('analyze/page', sendData)
      if (res) {
        if (res.code === 200) {
          this.loadingAnalyze = false
          var pageData = res.data
          pageData.data.forEach(analyzeRow => {
            if (analyzeRow.analyze.execStatus === 1) {
              analyzeRow.analyze.finishTime = ''
            }
          })
          this.analyzeData = pageData.data
          this.analyzePageChildMsg.total = pageData.totalNum
          this.analyzePageChildMsg.pageSize = pageData.pageSize
          this.analyzePageChildMsg.currentNum = pageData.currentNum
        }
      }
    },
    //分页
    handlePagePagination(pageparm) {
      this.analyzeDataPageparm = pageparm
      this.getAnalyzeData()
    },
    //跳转，进入具体的分析界面
    toContentAnalyzeHome(analyzeId) {
      let routeData = this.$router.resolve({
        path: '/analyzeContent',
        query: {projectId: this.projectId, analyzeId: analyzeId, path: '01.Biomarkers/01.OTU', index: '0'}
      });
      window.open(routeData.href, '_blank');
    },
    //获取分析总数
    async updateIsAnalysisOver() {
      const res = await this.$http.get('/project/analysisNum/' + this.projectId)
      if (res) {
        this.analysisNum = res.data
        if (res.data < 20) {
          this.analysisOver = false
        }
      }
    },
    //查看数据项目
    lookAnalyzeDetail(analyze) {
      this.showAnalyzeId = analyze.analyzeId
      this.showProjectId = analyze.projectId
      this.isShowAnalyzeDetail = true
    },
    //mixin
    addLoading(){
      this.loadingAnalyze = true
    },
    updatePageDataBySearch(){
      this.analyzeDataPageparm.currentNum = 1
        this.getAnalyzeData()
    },
    updatePageData(){
      this.getAnalyzeData()
    }
  }
}
</script>
<style scoped>
.el-breadcrumb {
  margin-bottom: 20px;
}

.btn-width-setting {
  width: 80px;
}

.box-card {
  margin: 20px 0;
}

.checkbox-setting {
  width: 100%;
  padding: 0 3px !important;
  margin: 3px 0 !important;
  display: flex;
  align-items: center;
}

.el-checkbox-group {
  max-height: 400px;
  overflow: auto;
}

.groupadd-checkbox-col {
  max-width: 300px;
}

.setting-text-one-row {
  display: flex;
  align-items: center;
}

.setting-btn-bgc:hover {
  background-color: rgba(0, 0, 0, .1);
  border-radius: 50%;
}

.status-public {
  line-height: 30px;
  height: 30px;
  width: 80px;
  color: #fff;
  text-align: center;
  border-radius: 20px;
}

.not-execute {
  background-color: #67c23a;
}

.executing {
  background-color: #409eff;
}

.execute-faild {
  background-color: #f56c6c;
}

#analysisNumText {
  font-size: 14px;
  height: 10px;
  align-content: center;
  margin-bottom: 20px;
}

::v-deep .ant-table-empty .ant-table-body {
  overflow-x: visible !important;
  overflow-y: visible !important;
}


.el-breadcrumb {
  line-height: 40px;
}

::v-deep .el-dialog__body {
  background-color: transparent !important;
}

::v-deep.el-dialog__wrapper {
  background-color: transparent;
  border: none;
}

::v-deep .ant-table-body {
  overflow-x: auto !important;
}

::v-deep.ant-table td {
  white-space: nowrap !important;
}
</style>
